var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_1342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8873 14.8727C28.8873 22.7738 22.4647 29.1964 14.5636 29.1964C6.66252 29.1964 0.23999 22.7738 0.23999 14.8727C0.23999 6.97162 6.66252 0.549088 14.5636 0.549088C22.4647 0.549088 28.8873 6.97162 28.8873 14.8727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5637 0.549088C22.4648 0.549088 28.8874 6.97162 28.8874 14.8727C28.8874 22.7738 22.4648 29.1964 14.5637 29.1964",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44458 4.75377C10.0354 -0.837073 19.0917 -0.837073 24.6825 4.75377C30.2733 10.3446 30.2733 19.4008 24.6825 24.9917",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_59_1342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7393 19.9985C12.6469 19.9985 12.5083 19.9523 12.4158 19.9061C12.1848 19.8137 12 19.5365 12 19.3055V10.6651C12 10.434 12.1848 10.1568 12.4158 10.0644C12.6469 9.97199 12.9241 9.97199 13.1551 10.1106L19.0232 14.4539C19.208 14.5925 19.3004 14.7773 19.3004 15.0084C19.3004 15.2394 19.208 15.4242 19.0232 15.5628L13.4991 19.6516C13.2712 19.8202 13.0228 19.9985 12.7393 19.9985Z",
    fill: "url(#paint0_radial_59_1342)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5305 19.8629C12.4381 19.8629 12.2995 19.8167 12.2071 19.7705C11.9761 19.6781 11.7913 19.4008 11.7913 19.1698V10.5294C11.7913 10.2984 11.9761 10.0212 12.2071 9.92876C12.4381 9.83635 12.7154 9.83635 12.9464 9.97496L18.8145 14.3183C18.9993 14.4569 19.0917 14.6417 19.0917 14.8727C19.0917 15.1037 18.9993 15.2886 18.8145 15.4272L12.9464 19.7705C12.8078 19.8167 12.6692 19.8629 12.5305 19.8629Z",
    fill: "#3A3A39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_59_1342",
    x: 0,
    y: -2,
    width: 31.3005,
    height: 33.9985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_59_1342"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_59_1342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1148 15.0259) rotate(-123.776) scale(11.841 93.1022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D95FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#7589EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_1342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6473,
    height: 28.6473,
    fill: "white",
    transform: "translate(0.23999 0.549088)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.764a03ef51dfd877f47c74c864d1dc86.svg";
export { ForwardRef as ReactComponent };